import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import confetti from 'canvas-confetti';
import { Button } from '@/components/ui/button';
import SEO from '@/components/SEO';

const DonationSuccess = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [randomMessage, setRandomMessage] = useState('');

  const successMessages = t('donation.success.messages', { returnObjects: true }) as string[];

  useEffect(() => {
    // Set random success message
    setRandomMessage(successMessages[Math.floor(Math.random() * successMessages.length)]);

    // Trigger confetti
    const duration = 5000;
    const end = Date.now() + duration;
    const colors = ['#39FF14', '#00FF00', '#32CD32'];

    (function frame() {
      confetti({
        particleCount: 5,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
        colors,
      });
      confetti({
        particleCount: 5,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
        colors,
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <SEO title="Welcome to the Club" path="/donation-success" noindex />
      <div className="max-w-lg w-full text-center space-y-8">
        {/* Success Icon */}
        <div className="text-8xl animate-pulse">🔥</div>

        {/* Title */}
        <h1 className="text-4xl font-bold terminal-glow">
          {t('donation.success.title')}
        </h1>

        {/* Random Message */}
        <p className="text-xl text-muted-foreground">
          {randomMessage}
        </p>

        {/* Decorative Box */}
        <div className="terminal-border p-6 space-y-4">
          <p className="text-primary">
            {t('donationSuccess.paymentConfirmed', 'Your payment was successful!')}
          </p>
          <p className="text-sm text-muted-foreground">
            {t('donationSuccess.leaderboardUpdate', 'Your donation will appear on the leaderboard shortly.')}
          </p>
        </div>

        {/* Back Button */}
        <Button
          onClick={() => navigate('/')}
          className="terminal-border neon-box-shadow hover:bg-primary hover:text-primary-foreground py-6 px-8 text-lg"
          variant="outline"
        >
          {t('donationSuccess.backToHome', '>>> BACK TO DUMONGO <<<')}
        </Button>
      </div>
    </div>
  );
};

export default DonationSuccess;
